import { Link } from 'react-router-dom'
import { SITE_DOMAIN } from '../lib/site'

export default function Brand({ compact = false }: { compact?: boolean }) {
  return <Link to="/" className={`brand real-brand ${compact?'compact':''}`} aria-label="HND Study Hub home">
    <img className="brand-logo-image" src="/hnd-study-hub-logo.png" alt="HND Study Hub" />
    {!compact && <span className="brand-wordmark"><strong>HND Study Hub</strong><small>{SITE_DOMAIN}</small></span>}
  </Link>
}
